import UIFetchService from "../Service/UIFetchService";
import auth from "../Service/AuthFetchService";

import React from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Table,
  Space,
  Input,
  Card,
  Transfer,
  Tree,
  Tag,
  Select,
  message,
  Tabs,
} from "antd";
import { ExclamationCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";

const { Column } = Table;

const tagColors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];

const allUiPerms = [
  {
    title: "全部",
    key: "datap:*",
    children: [
      {
        title: "权限管理",
        key: "datap:admin",
      },
      {
        title: "自助查询",
        key: "datap:querying:works",
      },
      {
        title: "报表平台",
        key: "datap:form:*",
        children: [
          {
            title: "实时大盘",
            key: "datap:form:group_realtime",
          },
          {
            title: "集团日报",
            key: "datap:form:group_daily",
          },
          {
            title: "集团周报",
            key: "datap:form:group_weekly",
          },
          {
            title: "集团月报",
            key: "datap:form:group_monthly",
          },
          {
            title: "集团年报",
            key: "datap:form:group_year",
          },
          {
            title: "用户生命周期",
            key: "datap:form:biz:user_life_cycle",
          },
          {
            title: "私域导流日报",
            key: "datap:form:referral_daily",
          },
          {
            title: "导流日报",
            key: "datap:form:referral_daily_v2",
          },
          // {
          //   title: "导流全景",
          //   key: "datap:form:full_referral",
          // },
          {
            title: "百词斩导流",
            key: "datap:form:bcz_referral",
          },
          {
            title: "薄芝导流",
            key: "datap:form:mintpie_referral",
          },
          {
            title: "电商私域导流",
            key: "datap:form:ec_referral",
          },
          {
            title: "数据平台监控",
            key: "datap:form:datap_access",
          },
          {
            title: "单用户曝光价值",
            key: "datap:form:ad_tracing",
          },
          {
            title: "新用户30日内导流转化",
            key: "datap:form:new_user_referral_30d",
          },
          {
            title: "实体商品-商品综合",
            key: "datap:form:real_product_form",
          },
          {
            title: "实体商品-履约信息",
            key: "datap:form:trade_form",
          },
          {
            title: "实时库存监控",
            key: "datap:form:rt_storage:all",
          },
          {
            title: "实时库存-百词斩",
            key: "datap:form:rt_storage:bcz",
          },
          {
            title: "实时库存-薄芝",
            key: "datap:form:rt_storage:mintpie",
          },
          {
            title: "KOL投放监控",
            key: "datap:form:kol_monitor",
          },
          {
            title: "未来技能核心报表",
            key: "datap:form:future_core",
          },
          {
            title: "百词斩市场舆情",
            key: "datap:form:bcz_yuqing",
          },
          // {
          //   title: "薄芝市场舆情",
          //   key: "datap:form:mintpie_yuqing",
          // },
          {
            title: "薄芝导流日报",
            key: "datap:form:mintpie_referral_daily_form",
          },
          // {
          //   title: "广告推荐效果监控",
          //   key: "datap:form:ad_recommend_monitor",
          // },
        ],
      },
      {
        title: "核心报表",
        key: "datap:form_core:*",
        children: [
          {
            title: "大营收多SKU总览",
            key: "datap:form:fc_overview",
          },
          {
            title: "大成英核心报表",
            key: "datap:form:adult_english",
          },
          {
            title: "大成英_分析_自有流量",
            key: "datap:form:mintpie_analyse_self_flow",
          },
          {
            title: "大成英_分析_番茄",
            key: "datap:form:mintpie_analyse_tomato",
          },
          {
            title: "百词斩核心报表",
            key: "datap:form:bcz_core",
          },
          {
            title: "百词斩分析报表_用户留存",
            key: "datap:form:bcz:retention",
          },
          {
            title: "未来技能核心报表",
            key: "datap:form:nocturne_core",
          },
          {
            title: "出国_核心",
            key: "datap:form:abroad_core",
          },
          {
            title: "出国_分析_托福",
            key: "datap:form:mintpie_analyse_toefl",
          },
          {
            title: "出国_分析_雅思",
            key: "datap:form:abroad_ielts",
          },
          {
            title: "K12核心报表",
            key: "datap:form:k12_core",
          },
          {
            title: "K12_分析_提分宝",
            key: "datap:form:k12_tifenbao",
          },
          {
            title: "K12_分析_新概念",
            key: "datap:form:mintpie_analyse_nce",
          },
          {
            title: "K12_分析_蛋糕",
            key: "datap:form:k12_cake",
          },
          {
            title: "硬件总览",
            key: "datap:form:hardware_overall",
          },
          {
            title: "硬件_核心_单词机",
            key: "datap:form:hardware_word_machine",
          },
          {
            title: "硬件_核心_词典笔",
            key: "datap:form:hardware_dictionary_pen",
          },
          {
            title: "硬件_核心_扫学机",
            key: "datap:form:hardware_learn_machine",
          },
          {
            title: "新阅读核心看板",
            key: "datap:form:newreading_core",
          },
          {
            title: "硬件_核心_彩屏单词机",
            key: "datap:form:hardware_color_machine",
          },
        ],
      },
      {
        title: "通用看板",
        key: "datap:generic:form:*",
        children: [
          {
            title: "通用核心报表",
            key: "datap:form:universal_core",
          },
          {
            title: "订单查询",
            key: "datap:form:order_query",
          },
          // {
          //   title: "活动数据",
          //   key: "datap:form:activity_data",
          // },
          {
            title: "课程质量评估监控",
            key: "datap:form:course_quality",
          },
          {
            title: "积分看板",
            key: "datap:form:credit_data",
          },
          {
            title: "百词斩用户画像",
            key: "datap:form:bcz_user_profile",
          },
          {
            title: "监控报警",
            key: "datap:form:general_monitor",
          },
          // {
          //   title: "大成英_分析_活动监控",
          //   key: "datap:form:mintpie_analyse_activity_2022",
          // },
        ],
      },
      {
        title: "内控",
        key: "datap:form:control:*",
        children: [
          {
            title: "内控在课无订单监控",
            key: "datap:form:control:no_order_monitor",
          },
        ],
      },
      {
        title: "画像系统",
        key: "datap:user_profile:*",
        children: [
          {
            title: "标签管理",
            key: "datap:user_profile:tags:management",
          },
          {
            title: "用户分群",
            key: "datap:user_profile:clustering",
          },
          {
            title: "画像查询",
            key: "datap:user_profile:querying",
          },
        ],
      },
      {
        title: "流量分析",
        key: "datap:real_time:*",
        children: [
          {
            title: "埋点日志",
            key: "datap:real_time:logs:view",
          },
          {
            title: "埋点管理",
            key: "datap:real_time:sampling:manage",
          },
          {
            title: "追踪参数基础信息维护",
            key: "datap:real_time:trace_basic_info:manage",
          },
        ],
      },
      {
        title: "天机",
        key: "datap:querying_guide:*",
        children: [
          {
            title: "模版配置",
            key: "datap:querying_guide:template",
          },
          {
            title: "可视化",
            key: "datap:querying_guide:visualization",
          },
          {
            title: "指标订阅",
            key: "datap:querying_indicator:indicator_report",
          },
          {
            title: "指标创建",
            key: "datap:querying_indicator:indicator",
          },
        ],
      },
      {
        title: "人力用工看板",
        key: "datap:form:hr:*",
        children: [
          {
            title: "公司层_人数",
            key: "datap:form:hr:group",
          },
          {
            title: "公司层_成本",
            key: "datap:form:hr:group_cost",
          },
          {
            title: "百词斩APP",
            key: "datap:form:hr:bcz",
          },
          {
            title: "成人英语SKU研发",
            key: "datap:form:hr:adult_eng_sku",
          },
          {
            title: "未来技能SKU研发",
            key: "datap:form:hr:future_sku",
          },
          {
            title: "产品导向SKU研发",
            key: "datap:form:hr:poc",
          },
          {
            title: "大营收多SKU市运销",
            key: "datap:form:hr:future_syx",
          },
          {
            title: "出国市运销",
            key: "datap:form:hr:mintpie",
          },
          {
            title: "业务平台",
            key: "datap:form:hr:abp_middle",
          },
          {
            title: "技术中台",
            key: "datap:form:hr:tech_middle",
          },
          {
            title: "履约供应链中台",
            key: "datap:form:hr:chain_middle",
          },
          {
            title: "人力",
            key: "datap:form:hr:hr",
          },
          {
            title: "财务",
            key: "datap:form:hr:finance",
          },
          {
            title: "法务合规",
            key: "datap:form:hr:legal",
          },
          {
            title: "行政",
            key: "datap:form:hr:administration",
          },
          {
            title: "销售_出国",
            key: "datap:form:hr:sales_abroad",
          },
          {
            title: "销售_大营收",
            key: "datap:form:hr:sales_fc",
          },
        ],
      },
    ],
  },
];

class RoleView extends React.Component {
  constructor() {
    super();

    this.state = {
      roleModal: {
        visible: false,
        uiPermsExpendKeys: [],
        ownsSchemas: [],
        action: "",
        valid: {
          roleName: {
            status: "",
            help: "",
          },
          perms: {
            status: "",
            help: "",
          },
        },
      },
      userModal: {
        visible: false,
        roleCode: "",
        roleName: "",
        users: [],
      },
      roles: [],
      uncommittedRole: {
        roleCode: "",
        roleName: "",
        uiPerms: {},
        ownsSchemas: {},
        resPerms: {},
      },
      allSchemes: [],
      projects: [],
      projectOptions: [],
      selectedOrigin: "",
      selectedProjectName: "",
    };
  }

  componentDidMount() {
    this.fetchProjects();
    this.refreshAllData();
  }

  async refreshAllData() {
    const roles = await UIFetchService.get("/api/v1/perm/roles");
    this.setState({ roles: roles });
  }

  showCreateRoleModal = () => {
    this.setState({
      roleModal: {
        visible: true,
        uiPermsExpendKeys: [
          "datap:*",
          "datap:form:*",
          "datap:form:*_core",
          "datap:real_time:form:*",
          "datap:user_profile:*",
          "datap:real_time:*",
          "datap:querying_guide:*",
        ],
        action: "create",
        valid: {
          roleName: {
            status: "",
            help: "",
          },
          perms: {
            status: "",
            help: "",
          },
        },
      },
      uncommittedRole: {
        roleCode: "",
        roleName: "",
        uiPerms: {},
        ownsSchemas: {},
        resPerms: {},
      },
    });
    auth.appendLog("CreateRoleModal");
  };

  roleModalHandleOk = async () => {
    let valid = true;
    const state = this.state.roleModal;

    if (isEmpty(this.state.uncommittedRole.roleName)) {
      message.error("角色名不能为空");
      return;
    }

    // if (JSON.stringify(this.state.uncommittedRole.uiPerms) === '{}') {
    //     state.valid.perms.status = 'error';
    //     state.valid.perms.help = '至少要选择一个权限';
    //     valid = false;
    // } else {
    //     state.valid.perms.status = 'success';
    //     state.valid.perms.help = '';
    // }

    this.setState({ roleModal: state });
    if (!valid) {
      return;
    }

    const err = await UIFetchService.post(
      "/api/v1/perm/role/prepare",
      this.state.uncommittedRole
    );
    if (err.roleName) {
      state.valid.roleName.status = "error";
      state.valid.roleName.help = err.roleName;
      valid = false;
    } else {
      state.valid.roleName.status = "success";
      state.valid.roleName.help = "";
    }

    if (err.perms) {
      state.valid.perms.status = "error";
      state.valid.perms.help = err.perms;
      valid = false;
    } else {
      state.valid.perms.status = "success";
      state.valid.perms.help = "";
    }

    this.setState({ roleModal: state });
    if (!valid) {
      return;
    }
    state.visible = false;
    this.setState({ roleModal: state });

    if (state.action === "create") {
      await UIFetchService.post(
        "/api/v1/perm/role/new",
        this.state.uncommittedRole
      );
      message.success("创建角色成功。");
    }
    if (state.action === "edit") {
      await UIFetchService.post(
        "/api/v1/perm/role/" + encodeURI(this.state.uncommittedRole.roleCode),
        this.state.uncommittedRole
      );
      message.success("保存角色成功。");
    }
    await this.refreshAllData();
  };

  roleModalHandleCancel = () => {
    const state = this.state.roleModal;
    state.visible = false;
    this.setState({ roleModal: state });
  };

  showEditRoleModal = async (roleCode) => {
    const role = await UIFetchService.get(
      "/api/v1/perm/role/" + encodeURI(roleCode)
    );
    this.setState({
      roleModal: {
        visible: true,
        uiPermsExpendKeys: ["datap:*", "datap:form:*", "datap:user_profile:*"],
        action: "edit",
        valid: {
          roleName: {
            status: "",
            help: "",
          },
          perms: {
            status: "",
            help: "",
          },
        },
      },
      uncommittedRole: role,
    });
    auth.appendLog("EditRoleModal");
  };

  roleTableHandleDelete(item) {
    const refresh = () => this.refreshAllData();

    Modal.confirm({
      title: "是否要删除角色：“" + item.roleName + "“?",
      icon: <ExclamationCircleOutlined />,
      content: "删除角色",
      onOk() {
        UIFetchService.method(
          "DELETE",
          "/api/v1/perm/role/" + encodeURI(item.code)
        ).then(() => refresh());
      },
      onCancel() {
        //console.log('Cancel');
      },
    });
  }

  roleUiPremsDidExpand = (keys) => {
    const state = this.state.roleModal;
    state.uiPermsExpendKeys = keys;
    this.setState({ roleModal: state });
  };

  roleUiPremsDidChecked = (keys, event) => {
    const state = this.state.uncommittedRole;
    const perms = {};

    keys.forEach((key) => {
      if (!key.endsWith(":*")) perms[key] = true;
    });
    state.uiPerms = perms;

    // if (event.checked) {
    //     perms[event.node.key] = true
    // } else {
    //     delete perms[event.node.key];
    // }
    this.setState({ uncommittedRole: state });
  };

  async showRoleUsersModal(record) {
    const roleCode = record.code;
    const users = await UIFetchService.get(
      "/api/v1/perm/role/" + encodeURI(roleCode) + "/users"
    );

    this.setState({
      userModal: {
        visible: true,
        roleCode: record.code,
        roleName: record.roleName,
        users: users,
      },
    });
  }

  async removeUserRole(userId, roleCode) {
    const roles = await UIFetchService.method(
      "DELETE",
      "/api/v1/perm/staff/" + userId + "/role",
      [roleCode]
    );
    if (!roles) {
      return;
    }

    const users = await UIFetchService.get(
      "/api/v1/perm/role/" + encodeURI(roleCode) + "/users"
    );
    if (users) {
      const state = this.state.userModal;
      state.users = users;
      this.setState({ userModal: state });
    }
  }

  userModalHandleClose = () => {
    const state = this.state.userModal;
    state.visible = false;
    this.setState({ userModal: state });
    this.refreshAllData();
  };

  render() {
    const handleOriginChange = (value) => {
      this.setState({
        selectedOrigin: value,
        selectedProjectName: "",
        projectOptions: this.state.projects,
        allSchemes: [],
      });
    };

    const handleProjectChange = (value) => {
      this.setState(
        {
          selectedProjectName: value,
        },
        () => {
          this.fetchSchemas();
        }
      );
    };

    const tableFilterSelects = (
      <>
        <span>数据源</span>
        <Select
          value={this.state.selectedOrigin}
          style={{ width: "35%", margin: 3 }}
          onChange={handleOriginChange}
        >
          <Select.Option key="ODPS">MaxCompute</Select.Option>
          <Select.Option key="Hologres">Hologres</Select.Option>
        </Select>
        <span>项目空间</span>
        <Select
          //defaultValue={this.state.selectedOrigin === 'ODPS' ? 'bcz_datap' : ''}
          style={{ width: "35%", marginLeft: 3 }}
          value={this.state.selectedProjectName}
          onChange={handleProjectChange}
        >
          {this.state.projectOptions[this.state.selectedOrigin]?.map((p) => (
            <Select.Option key={p}>{p}</Select.Option>
          ))}
        </Select>
      </>
    );

    return (
      <div hidden={this.props.hidden}>
        <Row>
          <Button type="primary" onClick={this.showCreateRoleModal}>
            + 新建角色
          </Button>
        </Row>
        <Modal
          title={"角色：“" + this.state.userModal.roleName + "”关联的用户"}
          visible={this.state.userModal.visible}
          onOk={this.userModalHandleClose}
          onCancel={this.userModalHandleClose}
        >
          <Row>
            {this.state.userModal.users.map((user, index) => (
              <Tag
                color={tagColors[index % tagColors.length]}
                style={{ margin: "0px 0px 5px 10px" }}
              >
                <Button
                  icon={<CloseOutlined />}
                  size="small"
                  type="link"
                  onClick={() =>
                    this.removeUserRole(user.key, this.state.userModal.roleCode)
                  }
                >
                  {user.title}
                </Button>
              </Tag>
            ))}
          </Row>
        </Modal>
        <Modal
          title={
            this.state.roleModal.action === "create" ? "新建角色" : "编辑角色"
          }
          visible={this.state.roleModal.visible}
          maskClosable={false}
          width={1000}
          onOk={this.roleModalHandleOk}
          onCancel={this.roleModalHandleCancel}
        >
          <Row>
            <Col style={{ alignSelf: "center" }}>
              <span>角色名：</span>
            </Col>
            <Col>
              <Input
                placeholder="不能为空，不能重复"
                allowClear
                style={{ width: 200 }}
                id="roleName"
                value={this.state.uncommittedRole.roleName}
                defaultValue={this.state.uncommittedRole.roleName}
                onChange={(e) => {
                  const state = this.state.uncommittedRole;
                  state.roleName = e.target.value;
                  this.setState({ uncommittedRole: state });
                }}
              />
            </Col>
          </Row>

          <Tabs>
            <Tabs.TabPane tab="菜单资源" key="menu">
              <Row style={{ overflowY: "auto", height: 500 }}>
                <Tree
                  checkable
                  onExpand={this.roleUiPremsDidExpand}
                  expandedKeys={this.state.roleModal.uiPermsExpendKeys}
                  autoExpandParent={true}
                  onCheck={this.roleUiPremsDidChecked}
                  checkedKeys={Object.keys(this.state.uncommittedRole.uiPerms)}
                  treeData={allUiPerms}
                />
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="数据资源" key="schemas">
              <Row style={{ height: 500 }}>
                <Col flex="100%">
                  <Transfer
                    dataSource={this.state.allSchemes}
                    rowKey={(rd) => rd.name}
                    targetKeys={(() => {
                      const owns = this.state.uncommittedRole.ownsSchemas;
                      if (owns === undefined) {
                        return undefined;
                      }
                      if (owns[this.state.selectedOrigin] === undefined) {
                        return undefined;
                      }
                      return owns[this.state.selectedOrigin][
                        this.state.selectedProjectName
                      ];
                    })()}
                    render={(item) => `${item.name}`}
                    style={{ width: "100%" }}
                    titles={[tableFilterSelects]}
                    onChange={(targetKeys, direction, moveKeys) => {
                      this.setState(({ uncommittedRole }) => {
                        if (uncommittedRole.ownsSchemas === undefined) {
                          uncommittedRole.ownsSchemas = {};
                        }
                        const owns = uncommittedRole.ownsSchemas;
                        if (owns[this.state.selectedOrigin] === undefined) {
                          owns[this.state.selectedOrigin] = {};
                        }
                        if (
                          owns[this.state.selectedOrigin][
                            this.state.selectedProjectName
                          ] === undefined
                        ) {
                          owns[this.state.selectedOrigin][
                            this.state.selectedProjectName
                          ] = [];
                        }
                        owns[this.state.selectedOrigin][
                          this.state.selectedProjectName
                        ] = targetKeys;
                        return { uncommittedRole };
                      });
                    }}
                    showSearch
                    pagination
                  />
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        </Modal>

        <div style={{ height: "20px" }}></div>
        <Row>
          <Col span={24}>
            <Table dataSource={this.state.roles}>
              <Column
                title="角色名称"
                key="action"
                render={(_, record) =>
                  record.code === "admin" ? (
                    <span style={{ color: "#FF0000", margin: "8px" }}>
                      {record.roleName}
                    </span>
                  ) : (
                    <Button
                      type="link"
                      size="small"
                      onClick={() => this.showEditRoleModal(record.code)}
                    >
                      {record.roleName}
                    </Button>
                  )
                }
              />
              <Column
                title="用户数量"
                key="ownsUserCount"
                render={(_, record) => (
                  <Space size="middle">
                    {record.ownsUserCount > 0 ? (
                      <Button
                        type="link"
                        size="small"
                        onClick={() => this.showRoleUsersModal(record)}
                      >
                        {record.ownsUserCount}
                      </Button>
                    ) : (
                      <span>{record.ownsUserCount}</span>
                    )}
                  </Space>
                )}
              />
              <Column title="创建时间" dataIndex="createdAt" key="createdAt" />
              <Column
                title="操作"
                key="action"
                render={(_, record) =>
                  record.code !== "admin" && (
                    <Space size="middle">
                      <Button
                        type="link"
                        size="small"
                        onClick={() => this.roleTableHandleDelete(record)}
                      >
                        删除
                      </Button>
                    </Space>
                  )
                }
              />
            </Table>
          </Col>
        </Row>
      </div>
    );
  }

  fetchSchemas() {
    UIFetchService.get(
      `/api/v1/metadata/schemas/all?origin=${this.state.selectedOrigin}&projectName=${this.state.selectedProjectName}`
    ).then((all) => {
      this.setState({ allSchemes: all }, () => {
        //this.fetchOwnedSchemas();
      });
    });
  }

  fetchProjects() {
    UIFetchService.get("/api/v1/schema/projects").then((projects) =>
      this.setState(
        {
          projects: projects,
          projectOptions: projects,
          selectedOrigin: "ODPS",
          selectedProjectName: "bcz_datap",
        },
        () => this.fetchSchemas()
      )
    );
  }
}

export default RoleView;
